import type PubSub from 'pubsub-js';

function getPubSub(): typeof PubSub | undefined {
  return window?.EM?.utils?.PubSub;
}

// To enable tracking logging use:
// window.FR = { ...window.FR, tracking: { ...window.FR?.tracking, mode: 'trace' } }
function printTrackingDev(type: string, dataToPublish: $TSFixMe) {
  if (
    typeof window !== 'undefined' &&
    window.FR &&
    window.FR.tracking &&
    window.FR.tracking.mode === 'trace'
  ) {
    console.info(type);
    console.info(dataToPublish);
  }
}

/**
 * Publish event into EveryMundo environment
 * @param {*} type Event to send
 * @param {*} data Data related to event
 */
export function publish(type: string, data: $TSFixMe) {
  printTrackingDev(type, { ...data });
  const pubSub = getPubSub();
  pubSub?.publish(type, { ...data });
}
